import {
  IItem,
  IPlugin,
  FieldDescriptions,
  IProjectPageParam,
  IApp,
  IPluginPanelOptions,
  IBaseControlOptions,
  IFieldDescription,
  IReviewConfig,
  IDropdownParams,
  ILabelLockConfig,
  IDropdownOption,
  ITableReviewData,
  IStringMap,
  IStringNumberMap,
  IStringStringArrayMap,
} from 'matrix-requirements-sdk/client';
import { sdkInstance } from './Instance';
import {
  IItemGetMap,
  IItemReviews,
  IReviewControlOptions,
  ReviewControlColumns,
} from './Interfaces';
import { ReviewHelper } from './helpers/ReviewHelper';
import { Tile } from './Tile';

const ml = sdkInstance.ml;
const app = sdkInstance.app as IApp;
const matrixsdk = sdkInstance.matrixsdk;
const globalMatrix = sdkInstance.globalMatrix;
const matrixSession = sdkInstance.matrixSession;
export class ScheduleReview implements IPlugin {
  public isDefault = true;

  initItem(item: IItem, jui: JQuery) {}

  initServerSettings() {}

  initProject() {}

  async getProjectPagesAsync(): Promise<IProjectPageParam[]> {
    return new Promise((resolve, reject) => {
      let that = this;
      let pages: IProjectPageParam[] = [];

      if (!globalMatrix.ItemConfig.getTimeWarp()) {
        pages.push({
          id: 'REVIEWS',
          title: 'Review Overview',
          folder: 'DASHBOARDS',
          order: 4000,
          icon: 'fal fa-stamp',
          usesFilters: false,
          render: (options: IPluginPanelOptions) =>
            app.waitForMainTree(() => that.renderReviewProjectPage(options)),
        });
      }

      resolve(pages);
    });
  }

  supportsControl(fieldType: string): boolean {
    return false;
  }

  createControl(ctrl: JQuery, options: IBaseControlOptions) {
    return false;
  }

  updateMenu(ul: JQuery) {
    return;
  }

  private renderReviewProjectPage(options: IPluginPanelOptions) {
    let that = this;

    if (options.controlState === sdkInstance['ControlState'].Print) {
      return;
    }

    document.title = 'Reviews - ' + matrixSession.getProject();

    options.control.html('');

    app.waitForMainTree(renderTabs);

    function renderTabs() {
      options.control.html('');
      // paint the tabs
      let container = $("<div class='panel-body-v-scroll' >").appendTo(
        options.control,
      );

      if (!matrixSession.isReview()) {
        container.append(
          $('<p style="color:red;margin:10px">Review module not licensed</p>'),
        );
        return;
      }

      var tabpanel = $(
        '<div role="tabpanel" class="tabpanel-container " style="padding:0px;">',
      );
      container.append(tabpanel);

      let tabpanelul = $(
        '<ul class="nav nav-tabs contextFrameTabs" role="tablist">',
      );
      tabpanel.append(tabpanelul);
      let tabpanels = $(
        '<div class="tab-content" style="height:' +
          ($('#itemDetails').height() - tabpanelul.height() - 70) +
          'px">',
      );
      tabpanel.append(tabpanels);

      let progress = $('<div>')
        .appendTo(tabpanels)
        .append(ml.UI.getSpinningWait('retrieving review info...'));

      tabpanelul.append(
        '<li role="presentation" class="active"><a href="#MYREVIEWS"  role="tab" data-toggle="tab">My Reviews</a></li>',
      );
      let myReviewPanel = $(
        '<div role="tabpanel"  style="height:100%" class="tabpaneltab tab-pane active" id="MYREVIEWS" >',
      );
      tabpanels.append(myReviewPanel);

      tabpanelul.append(
        '<li role="presentation"><a href="#ALLREVIEWS"  role="tab" data-toggle="tab">All Reviews</a></li>',
      );
      let allReviewPanel = $(
        '<div role="tabpanel"  style="height:100%" class="tabpaneltab tab-pane" id="ALLREVIEWS" >',
      );
      tabpanels.append(allReviewPanel);

      tabpanelul.append(
        '<li role="presentation"><a href="#ALLITEMS"  role="tab" data-toggle="tab">Reviews Per Item</a></li>',
      );
      let itemReviewPanel = $(
        '<div role="tabpanel"  style="height:100%" class="tabpaneltab tab-pane" id="ALLITEMS" >',
      );
      tabpanels.append(itemReviewPanel);

      // all categories with a review control
      let catsWithReview = globalMatrix.ItemConfig.getFieldsOfType(
        'reviewControl',
      ).map(function (rcs) {
        return 'category=' + rcs.category;
      });
      if (!catsWithReview.length) {
        progress.remove();
        myReviewPanel.html(
          'There are no categories with review fields in this project.',
        );
        allReviewPanel.html(
          'There are no categories with review fields in this project.',
        );
        return;
      }

      app
        .getNeedlesAsync(
          catsWithReview.join(' OR '),
          false,
          false,
          '*',
          false,
          true,
        )
        .done((reviews: IItem[]) => {
          that.renderReviews(myReviewPanel, reviews, true);
          that.renderReviews(allReviewPanel, reviews, false);
          that.renderItems(itemReviewPanel, catsWithReview, reviews);

          progress.remove();
        });
    }
  }

  // project pages show in the top in Projects, Reports and Documents
  private renderReviews(control: JQuery, needles: IItem[], onlyMine: boolean) {
    let that = this;
    let container = $(
      "<div class='panel-body-v-scroll' style='padding: 0 12px;'>",
    ).appendTo(control);

    if (onlyMine) {
      $('<h2>My Reviews</h2>').appendTo(container);
      // only show reviews for me and the stats for me
    } else {
      $('<h2>Overview Reviews</h2>').appendTo(container);
    }
    let filters = $('<div>').appendTo(container);
    $(
      '<div class="alignHorizontal" ><div class="checkbox" ><label><input type="checkbox" data-hide="review_open" checked >show open</label></div></div>',
    ).appendTo(filters);
    $(
      '<div class="alignHorizontal" ><div class="checkbox" ><label><input type="checkbox" data-hide="review_done" checked >show done</label></div></div>',
    ).appendTo(filters);
    $('input', container).change(function () {
      $.each($('input', container), function (idx, input) {
        if ($(input).data('hide')) {
          let sh = $('.' + $(input).data('hide'), container);
          if ($(input).prop('checked')) {
            sh.show();
            sh.removeClass('hideCopy');
          } else {
            sh.hide();
            sh.addClass('hideCopy');
          }
        }
      });
    });

    let details = $('<ul>').appendTo(container);
    ml.UI.copyBuffer(filters, 'copy to clipboard', details, control);

    let shown = 0;
    $.each(needles, function (idx, needle) {
      let fieldId = globalMatrix.ItemConfig.getFieldsOfType(
        'reviewControl',
        ml.Item.parseRef(needle.id).type,
      )[0].field.id;

      let tableData = that.getReviewTable(needle);

      if (tableData.length == 0) return;

      let reviewUsers = ReviewHelper.getReviewers(tableData);
      if (onlyMine && reviewUsers.indexOf(matrixSession.getUser()) == -1)
        return; // review does not concern me

      let itemCount = tableData.length;
      let columns = Object.keys(tableData[0]);
      let todos = ReviewHelper.getItemsToDoByUser(fieldId, tableData);

      // figure out how many reviews have to be done.
      let userCount = onlyMine ? 1 : reviewUsers.length; // if it's only about mine, don't care about other users
      let total = itemCount * userCount;
      let stillTodo = 0;

      if (onlyMine) {
        stillTodo = todos[matrixSession.getUser()]
          ? todos[matrixSession.getUser()].length
          : 0;
      } else {
        // add up all the todo's for all users
        $.each(columns, function (cidx, col) {
          if (todos[col]) {
            stillTodo += todos[col].length;
          }
        });
      }

      shown++;
      if (stillTodo) {
        details.append(
          "<li class='review_open'><b>" +
            that.getNeedleRef(needle) +
            '</b> ' +
            Math.floor(((total - stillTodo) * 100) / total) +
            '% done</li>',
        );
      } else {
        details.append(
          "<li class='review_done'><b style='text-decoration: line-through'>" +
            that.getNeedleRef(needle) +
            '</b>  done</li>',
        );
      }
    });

    if (!shown) {
      details.append("<li class=''><b>no reviews yet</b></li>");
    }

    details.highlightReferences();
  }

  private getNeedleRef(needle: IItem) {
    return this.getItemRef(ml.Item.parseRef(needle.id).id);
  }

  private getItemRef(id: string) {
    return (
      "<span class='hideCopy'>" +
      id +
      "!</span><span class='replaceCopy' data-with='" +
      id +
      "!'></span>"
    );
  }

  private renderItems(
    control: JQuery,
    catsWithReview: string[],
    needles: IItem[],
  ) {
    let that = this;
    let cp = $(
      "<div class='panel-body-v-scroll' style='padding-top:10px'>",
    ).appendTo(control);
    let h1 = $("<h1 class='hideCopy'>").html('Status by item').appendTo(cp);
    ml.UI.copyBuffer(h1, 'copy to clipboard', cp, cp);

    let allCats = globalMatrix.ItemConfig.getCategories(true).filter(
      function (cat) {
        return cat != 'REPORT' && catsWithReview.indexOf(cat) == -1;
      },
    );
    let cat = localStorage.getItem(
      matrixSession.getProject() + '_lastReviewDashbordCat',
    );
    cat = cat ? cat : allCats[0];

    let dropdown =
      $(`<span class="hideCopy dropdown" style="float:right; margin-right:12px">
        <button class="btn btn-xs dropdown-toggle" type="button" data-toggle="dropdown">
            <span id="selectedCat" >${cat}</span>&nbsp;
            <span class="caret"></span>
        </button>
        <ul class="dropdown-menu dropdown-menu-right">
        ${allCats.map((c) => `<li class="catselect" data-cat="${c}"><a href="javascript:void(0)">${c}</a></li>`).join('\n')}
        </ul>
        </span>`).appendTo(h1);

    // build a list with all items, for each item know in which reviews it was passed, failed, todo
    let reviewAnalysis: IItemReviews = {};
    $.each(needles, function (idx, needle) {
      that.analyzeReview(needle, reviewAnalysis);
    });

    let container = $('<div>').appendTo(cp);
    this.renderItemsCat(container, cat, reviewAnalysis);

    $('.catselect', dropdown).click((event: JQueryEventObject) => {
      let selectedCat = $(event.delegateTarget).data('cat');
      localStorage.setItem(
        matrixSession.getProject() + '_lastReviewDashbordCat',
        selectedCat,
      );
      $('#selectedCat', dropdown).html(selectedCat);
      that.renderItemsCat(container, selectedCat, reviewAnalysis);
    });
  }

  renderItemsCat(container: JQuery, cat: string, reviewAnalysis: IItemReviews) {
    let that = this;

    container.html('');
    // prepare table
    let table = $("<table class='table table-bordered'>").appendTo(container);
    let head = $('<thead>').appendTo(table);
    let trh = $('<tr>').appendTo(head);
    $('<th>').html('Item').appendTo(trh);
    let rc = $('<th>').html('Reviews').appendTo(trh);
    $(
      '<div class="checkbox hideCopy" ><label><input type="checkbox" data-hide="notReviewed" checked >Show not reviewed items</label></div>',
    ).appendTo(rc);

    let rsc = $('<th>').html('Review Status').appendTo(trh);
    $(
      '<div class="checkbox hideCopy" ><label><input type="checkbox" data-hide="todo" checked >todo</label></div>',
    ).appendTo(rsc);
    $(
      '<div class="checkbox hideCopy" ><label><input type="checkbox" data-hide="failed" checked >failed</label></div>',
    ).appendTo(rsc);
    $(
      '<div class="checkbox hideCopy" ><label><input type="checkbox" data-hide="passed" checked >passed</label></div>',
    ).appendTo(rsc);
    let rwd = $('<th>').html('Review Date').appendTo(trh);
    $(
      '<div class="checkbox hideCopy" ><label><input type="checkbox" data-hide="allReviews" checked >Show all but last reviews</label></div>',
    ).appendTo(rwd);
    $(
      '<div class="checkbox hideCopy" ><label><input type="checkbox" data-hide="lastReviews" checked >Show last reviews</label></div>',
    ).appendTo(rwd);
    let tbody = $('<tbody>').appendTo(table);

    let hasContent = false;
    let itemsInCat = app
      .getChildrenIdsRec('F-' + cat + '-1')
      .sort(function (a, b) {
        return ml.Item.parseRef(a).number - ml.Item.parseRef(b).number;
      });

    $.each(itemsInCat, function (itemIdx, item) {
      // add a row for item
      let tdItem: JQuery;

      if (reviewAnalysis[item]) {
        // item was in some reviews
        let reviewCount = reviewAnalysis[item].all.length;
        // check if all have the same status (in that case the filter needs to remove all)
        let overallStatus =
          reviewAnalysis[item].passed.length == reviewCount
            ? 'passed'
            : reviewAnalysis[item].failed.length == reviewCount
              ? 'failed'
              : reviewAnalysis[item].todo.length == reviewCount
                ? 'todo'
                : '';

        for (let idx = 0; idx < reviewCount; idx++) {
          // a new row for this review
          hasContent = true;
          let tr = $(`<tr class='item_${cat} wasReviewed'>`).appendTo(tbody);

          if (overallStatus) {
            tr.addClass(overallStatus);
          }

          if (idx == 0) {
            // add a first column with item id
            tdItem = $(
              `<td rowspan=${reviewAnalysis[item].all.length}>${that.getItemRef(item)}</td>`,
            ).appendTo(tr);
          }
          // now add review results
          let needle = reviewAnalysis[item].all[idx];

          let passed = reviewAnalysis[item].passed.indexOf(needle.id) != -1;
          let failed = reviewAnalysis[item].failed.indexOf(needle.id) != -1;

          // set the text to passed, failed, to do
          let text = passed ? 'passed' : failed ? 'failed' : 'to do';
          let statusClass = passed ? 'passed' : failed ? 'failed' : 'todo';

          let td1 = $(
            "<td class='" +
              statusClass +
              "'>" +
              that.getNeedleRef(needle) +
              '</td>',
          ).appendTo(tr);
          let td2 = $(
            "<td class='" + statusClass + "'>" + text + '</td>',
          ).appendTo(tr);
          let td3 = $(
            "<td class='" + statusClass + "'>" + needle.modDate + '</td>',
          ).appendTo(tr);

          if (idx != reviewCount - 1) {
            // not the last review so we mark it
            td1.addClass('allReviews');
            td2.addClass('allReviews');
            td3.addClass('allReviews');
          }
        }
      } else {
        let tr = $("<tr class='item_" + cat + " notReviewed'>").appendTo(tbody);
        $('<td>' + that.getItemRef(item) + '</td>').appendTo(tr);
        $("<td colspan='3'>not reviewed</td>").appendTo(tr);
      }
    });

    if (hasContent) {
      table.highlightReferences();
      $('input', container).change(function () {
        $('body').css('cursor', 'progress');

        window.setTimeout(() => {
          that.showHide(container);
          $('body').css('cursor', 'default');
        }, 1);
      });
    } else {
      container.html(
        `<p>There are no reviewed items in the category ${cat}</p>`,
      );
    }
  }

  private showHide(container: JQuery) {
    $('.hideCopy', container).show().removeClass('hideCopy');
    $.each($('input', container), function (idx, input) {
      if ($(input).data('hide') && !$(input).prop('checked')) {
        $('.' + $(input).data('hide'), container)
          .hide()
          .addClass('hideCopy');
      }
    });
  }

  // go through a review and figure which items were passed or failed...
  private analyzeReview(needle: IItem, reviewAnalysis: IItemReviews) {
    let that = this;

    let tableData = that.getReviewTable(needle);

    if (tableData.length == 0) return;

    let fieldId = globalMatrix.ItemConfig.getFieldsOfType(
      'reviewControl',
      ml.Item.parseRef(needle.id).type,
    )[0].field.id;
    let reviewId = needle.id;

    let passedItems: string[] = [];
    let failedItems: string[] = [];
    let todoItems: string[] = [];
    ReviewHelper.analyzeReview(
      fieldId,
      tableData,
      passedItems,
      failedItems,
      todoItems,
    );

    for (let item of passedItems) {
      if (!reviewAnalysis[item]) {
        reviewAnalysis[item] = { passed: [], failed: [], todo: [], all: [] };
      }
      reviewAnalysis[item].passed.push(reviewId);
      reviewAnalysis[item].all.push(needle);
    }
    for (let item of failedItems) {
      if (!reviewAnalysis[item]) {
        reviewAnalysis[item] = { passed: [], failed: [], todo: [], all: [] };
      }
      reviewAnalysis[item].failed.push(reviewId);
      reviewAnalysis[item].all.push(needle);
    }
    for (let item of todoItems) {
      if (!reviewAnalysis[item]) {
        reviewAnalysis[item] = { passed: [], failed: [], todo: [], all: [] };
      }
      reviewAnalysis[item].todo.push(reviewId);
      reviewAnalysis[item].all.push(needle);
    }
  }

  private getReviewTable(needle: IItem): IStringMap[] {
    let tableData: IStringMap[] = [];

    let fieldId = globalMatrix.ItemConfig.getFieldsOfType(
      'reviewControl',
      ml.Item.parseRef(needle.id).type,
    )[0].field.id;

    if (needle[fieldId]) {
      let rawValue = needle[fieldId];
      let val = <ITableReviewData>(
        (rawValue ? JSON.parse(rawValue) : { reviewTable: [] })
      );
      if (!val.reviewtable) {
        // review items which have never been scheduled
        val.reviewtable = [];
      }
      tableData = val.reviewtable;
    }

    return tableData;
  }
  getTiles() {
    return [new Tile()];
  }
  async getDashboardLinksForAnalyticsAsync() {
    return [
      {
        pageId: 'REVIEWS',
        title: 'Review Overview',
      },
    ];
  }
}

sdkInstance.plugins.register(new ScheduleReview());

/*****/
